<template>
  <el-tooltip effect="dark" :open-delay="500" :content="getGoodName" placement="right-end">
    <div
      v-if="info.shows"
      :class="{ 'product-card': true, 'cursor-pointer': productData.status === 3 }"
      @click.stop="productsDetails(false)"
    >
      <div class="image-container cursor-pointer" @click.stop="productsDetails(false)">
        <div class="image-wrapper">
          <img :src="imgSrc || defaultProduct" alt="" class="product-image" />
          <!-- 图片遮罩层，用于鼠标悬停效果 -->
          <div class="image-overlay">
            <!-- <i class="fas fa-search-plus overlay-icon"></i> -->
          </div>
        </div>
      </div>
      <div class="product-info">
        <div class="product-name cursor-pointer" @click.stop="productsDetails(false)">
          <span class="name-text" :style="`-webkit-line-clamp: ${info.shows.pcCard[0].row || 1};`">
            {{ getGoodName }}
          </span>
        </div>
        <div v-for="(child, childIndex) in info.shows.pcCard" :key="child.content">
          <template v-if="childIndex !== 0">
            <div v-if="childIndex === info.shows.pcCard.length - 1">
              <div v-if="info.shows.pcCard.length > 2" class="flex flex-between flex-row-center">
                <div
                  class="pricing-info line-wrap"
                  :style="`-webkit-line-clamp: ${child.row || 1};`"
                  style="flex: 1;"
                  v-if="child.content.includes('Price') || child.content.includes('price')"
                >
                  <span v-html="getTagValue(child.content)"></span>
                  <span class="price-unit" v-if="productData.unit && child.content.includes('<price>')"
                    >/{{ productData.unit }}</span
                  >
                  <!-- <div v-else>
                    <span class="price" v-html="getTagValue(child.content)"></span>
                  </div> -->
                </div>
                <div v-else class="line-wrap" :style="`-webkit-line-clamp: ${child.row || 1};`">
                  <span
                    class="minBuyQty"
                    v-if="child.content.includes('minBuyQty')"
                    v-html="getTagValue(child.content)"
                  ></span>
                  <span v-else v-html="getTagValue(child.content)"></span>
                </div>
                <div class="footer-actions" @click.stop>
                  <div class="cart-controls">
                    <div
                      :class="{ 'add-to-cart-btn': true, 'disabled-btn': productData.status !== 3 }"
                      v-if="Number(productData.cartQty) === 0"
                      @click.stop="isMoreModel ? openProductDetails() : addShoppingCartFun(0, true)"
                    >
                      <i class="fas fa-cart-plus cart-icon"></i>
                    </div>
                    <template v-else>
                      <ControlDisabledInput
                        :modelValue="productData.orderQuantity"
                        @changeNum="openProductDetails"
                        :disabled="productData.status !== 3"
                        v-if="isMoreModel"
                      ></ControlDisabledInput>
                      <ControlInput
                        :modelValue="productData.orderQuantity"
                        :min="0"
                        :min-value="Number(productData.minQty)"
                        :step="Number(productData.uQty)"
                        :disabled="productData.outOfStock || productData.status !== 3"
                        @change="addShoppingCartFun"
                        @crearValue="clearNum"
                        v-else
                      ></ControlInput>
                    </template>
                  </div>
                </div>
              </div>
              <template v-else>
                <div
                  class="pricing-info line-wrap"
                  :style="`-webkit-line-clamp: ${child.row || 1};`"
                  v-if="child.content.includes('Price') || child.content.includes('price')"
                >
                  <span v-html="getTagValue(child.content)"></span>
                  <span class="price-unit" v-if="productData.unit && child.content.includes('<price>')"
                    >/{{ productData.unit }}</span
                  >
                </div>
                <div v-else class="line-wrap" :style="`-webkit-line-clamp: ${child.row || 1};`">
                  <span
                    class="minBuyQty"
                    v-if="child.content.includes('minBuyQty')"
                    v-html="getTagValue(child.content)"
                  ></span>
                  <span v-else v-html="getTagValue(child.content)"></span>
                </div>
                <div class="footer-actions" style="max-width:100%" @click.stop>
                  <span></span>
                  <div class="cart-controls">
                    <div
                      :class="{ 'add-to-cart-btn': true, 'disabled-btn': productData.status !== 3 }"
                      v-if="Number(productData.cartQty) === 0"
                      @click.stop="isMoreModel ? openProductDetails() : addShoppingCartFun(0, true)"
                    >
                      <i class="fas fa-cart-plus cart-icon"></i>
                    </div>
                    <template v-else>
                      <ControlDisabledInput
                        :modelValue="productData.orderQuantity"
                        @changeNum="openProductDetails"
                        :disabled="productData.status !== 3"
                        v-if="isMoreModel"
                      ></ControlDisabledInput>
                      <ControlInput
                        :modelValue="productData.orderQuantity"
                        :min="0"
                        :min-value="Number(productData.minQty)"
                        :step="Number(productData.uQty)"
                        :disabled="productData.outOfStock || productData.status !== 3"
                        @change="addShoppingCartFun"
                        @crearValue="clearNum"
                        v-else
                      ></ControlInput>
                    </template>
                  </div>
                </div>
              </template>
            </div>
            <div v-else>
              <div
                class="pricing-info line-wrap"
                :style="`-webkit-line-clamp: ${child.row || 1};`"
                v-if="child.content.includes('Price') || child.content.includes('price')"
              >
                <!-- <div v-if="child.content.includes('linePrice')">
                </div> -->
                <span v-html="getTagValue(child.content)"></span>
                <span class="price-unit" v-if="productData.unit && child.content.includes('<price>')"
                  >/{{ productData.unit }}</span
                >
                <!-- <div v-else>
                  <span class="price" v-html="getTagValue(child.content)"></span>
                </div> -->
              </div>
              <div v-else class="line-wrap" :style="`-webkit-line-clamp: ${child.row || 1};`">
                <span
                  class="minBuyQty"
                  v-if="child.content.includes('minBuyQty')"
                  v-html="getTagValue(child.content)"
                ></span>
                <span v-else v-html="getTagValue(child.content)"></span>
              </div>
            </div>
          </template>
        </div>
        <div class="tags-section">
          <div class="relative">
            <div class="tags-container" ref="tagsContainer" :class="{ 'has-overflow': showTagsDropdown }">
              <span
                v-show="productData.extaCode"
                :class="`tag exchange ${productData.status === 3 ? 'cursor-pointer' : ''}`"
                @click.stop="productsDetails(true)"
              >
                互换
              </span>
              <span v-show="productData.promotion" class="tag promotion">
                {{ productData.promotion }}
              </span>
              <span v-show="productData.limitString" class="tag new">
                {{ productData.limitString.split("，")[0] }}
              </span>
              <span class="tag coupon" v-for="item in productData.coupons" :key="item.id">
                <span class="coupon-icon">券</span>
                {{ item.title }}
              </span>
            </div>
            <!-- 下拉按钮 -->
            <div v-if="showTagsDropdown" class="tags-dropdown-btn" @click.stop="toggleTagsPopup">
              <i class="fas fa-ellipsis-h"></i>
            </div>
          </div>

          <!-- <div class="promotion-text" v-if="productData.promotion">
            {{ productData.promotion }}
          </div> -->
        </div>
      </div>
      <!-- 标签弹窗 -->
      <div v-if="showTagsPopup" class="tags-popup-overlay" @click.stop="closeTagsPopup">
        <div class="tags-popup" @click.stop>
          <div class="popup-header">
            <h3>全部标签</h3>
            <button class="close-btn" @click.stop="closeTagsPopup">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="popup-content">
            <div class="all-tags">
              <span
                v-show="productData.extaCode"
                :class="`tag exchange ${productData.status === 3 ? 'cursor-pointer' : ''}`"
                @click.stop="productsDetails(true)"
              >
                互换
              </span>
              <span v-show="productData.promotion" class="tag promotion">
                {{ productData.promotion }}
              </span>
              <span v-show="productData.limits?.rule" class="tag new">
                {{ productData.limits?.rule }}
              </span>
              <span class="tag coupon" v-for="item in productData.coupons" :key="item.id">
                <span class="coupon-icon">券</span>
                {{ item.title }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <ProductsDetailsBox @refreshList="refreshList" ref="productsDetailsBox" />
    </div>
  </el-tooltip>
</template>

<script>
import ProductsDetailsBox from "@/components/ProductsDetailsBox";
import shoppingCarImg from "@/assets/img/shopping-car.png";
import { addShoppingCart } from "@/api/shoppingCart";
import ControlInput from "./ControlInput.vue";
import ControlDisabledInput from "./ControlDisabledInput.vue";
import defaultProduct from "@/assets/img/newProducts/deafultProduct.png";
import { mapState } from "vuex";
import { extractTagContent } from "@/views/newProducts/minin/homepage.js";
import { deleteShoppingCart } from "@/api/shoppingCart/index.js";

export default {
  name: "ProductOne",
  components: {
    ControlInput,
    ControlDisabledInput,
    ProductsDetailsBox
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState("goods", {
      goodNameRules: state => {
        return state.goodNameRules;
      },
      goodsItemUpdate: state => {
        return state.goodsItemUpdate;
      }
    }),
    ...mapState("user", {
      userInfo: state => {
        return state.userInfo;
      }
    }),
    getGoodName() {
      // console.log("item", this.info);
      if (this.info.shows) {
        const list = this.info.shows.pcCard;
        console.log("list", list);
        if (list && list.length) {
          return list[0].content;
        }
      }
      return "";
      // return getGoodsName(this.goodNameRules, this.info);
    },
    imgSrc() {
      if (this.info.images && this.info.images.length > 0) {
        return this.info.images[0];
      }
      return "";
    },
    isMoreModel() {
      return this.info.isSpecification;
    }
  },

  watch: {
    goodsItemUpdate: {
      handler(newV) {
        if (
          newV &&
          this.productData &&
          newV.uuid === this.productData.uuid &&
          newV.cartQty !== this.productData.cartQty
        ) {
          const item = window.tool.deepClone(newV);
          if (Number(item.minBuyQty) && Number(item.uQty)) {
            item.minQty = tool.getLCM(Number(item.minBuyQty), Number(item.uQty));
          } else {
            item.minQty = 1;
          }
          item.orderQuantity = Number(item.cartQty) || item.minQty || 1;
          this.productData = item;
        }
      },
      deep: true
    },
    info: {
      handler(newV, oldV) {
        const item = window.tool.deepClone(newV);
        if (item && oldV && item.uuid === oldV.uuid && item.cartQty !== oldV.cartQty) {
          // const _item = window.tool.deepClone(newV);
          // this.$store.commit("goods/setGoodsItemUpdate", _item);
        }
        if (Number(item.minBuyQty) && Number(item.uQty)) {
          item.minQty = tool.getOrderQuantity(Number(item.minBuyQty), Number(item.uQty));
        } else {
          item.minQty = 1;
        }
        item.orderQuantity = Number(item.cartQty) || item.minQty || 1;
        this.productData = item;
        this.$nextTick(() => {
          this.checkTagsOverflow();
        });
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      shoppingCarImg,
      productData: {},
      defaultProduct,
      showTagsDropdown: false,
      showTagsPopup: false
    };
  },
  mounted() {
    this.checkTagsOverflow();
    // 监听窗口变化
    window.addEventListener("resize", this.checkTagsOverflow);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkTagsOverflow);
  },
  methods: {
    getTagValue(str) {
      console.log("str", str);
      const price = extractTagContent(str);
      console.log("price", price);
      return price;
    },
    //删除
    clearNum() {
      this.$confirm("确认从购物车删除该商品吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteCartItem();
          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    async deleteCartItem() {
      try {
        console.log("this.productData", this.productData);
        await deleteShoppingCart({ ids: [this.productData.cartId] });
        this.$message.success("删除成功");
        await this.$bus.$emit("shoppingCartRefresh");
        this.$set(this.productData, "cartQty", 0);
        this.$store.commit("goods/setGoodsItemUpdate", tool.deepClone(this.productData));
      } catch (error) {
        this.$message.error("删除失败," + error.message);
      }
    },
    checkTagsOverflow() {
      this.$nextTick(() => {
        const container = this.$refs.tagsContainer;
        if (!container) return;

        // console.log("容器scrollHeight:", container.scrollHeight, "clientHeight:", container.clientHeight);
        const hasOverflow = container.scrollHeight > 30;
        this.showTagsDropdown = hasOverflow;
      });
    },
    toggleTagsPopup() {
      this.showTagsPopup = !this.showTagsPopup;
    },
    closeTagsPopup() {
      this.showTagsPopup = false;
    },
    productsDetails(showExchange) {
      if (this.productData.status !== 3) {
        return;
      }
      if (showExchange) {
        this.productData.showExchange = true;
      } else {
        if (this.productData.showExchange) {
          delete this.productData.showExchange;
        }
      }
      this.$router.push({
        path: "/new-products/product-details",
        query: {
          data: encodeURIComponent(JSON.stringify(this.productData))
        }
      });
    },
    openProductDetails() {
      if (this.productData.status !== 3) {
        return;
      }
      if (!this.userInfo.userId) {
        this.$router.push({ path: "/login" });
        return;
      }
      this.$refs.productsDetailsBox.show(this.productData);
    },
    refreshList(n) {
      const cartQty = Number(n) + Number(this.productData.cartQty);
      const obj = tool.deepClone(this.productData);
      obj.cartQty = cartQty;
      obj.orderQuantity = cartQty;
      this.$set(this, "productData", obj);
      this.$store.commit("goods/setGoodsItemUpdate", tool.deepClone(obj));
      this.$emit("refreshProductList");
    },
    //添加到购物车
    async addShoppingCartFun(n, flag) {
      if (this.productData.status !== 3) {
        return;
      }
      if (!this.userInfo.userId) {
        this.$router.push({ path: "/login" });
        return;
      }
      const row = this.productData;
      const cartQty = Number(n) || this.productData.orderQuantity || 1;
      const data = [
        {
          goodsType: row.type, // 商品类型，0:普通，1:补货，2:促销组合，3:服务项目，4:套餐
          goodsId: row.id, // 商品ID
          code: row.code, // 商品编码
          name: row.name, // 商品名称
          property: row.property, // 商品性质
          warehouse: row.warehouse, // 仓库
          productBatch: row.productBatch, // 生产批号
          price: !isNaN(Number(row.price)) ? row.price : "0", // 加购时价格
          qty: String(cartQty), // 数量
          remarks: row.remarks, // 备注
          checked: false, // 是否已选择
          areaDetailId: 0 // 商城区域详情ID，用来实时关联修理厂用
        }
      ];
      try {
        const res = await addShoppingCart({ cover: true, data: data });
        // console.log(res);
        if (res && res.length > 0) {
          this.productData.cartId = res[0];
        }
        if (flag) {
          this.$message.success("已成功加入购物车");
        } else {
          this.$message.success("修改购物车数量成功");
        }
        await this.$bus.$emit("shoppingCartRefresh");
        // this.productData.cartQty = cartQty;
        this.$set(this.productData, "cartQty", cartQty);
        this.$store.commit("goods/setGoodsItemUpdate", tool.deepClone(this.productData));
        await this.$emit("refreshProductList");
      } catch (error) {
        this.$message.error(error.message || "操作失败");
      }
    },
    // 格式化单个价格
    formatSinglePrice(priceStr) {
      if (!priceStr) return [];
      const parts = priceStr.split(".");
      const result = [];
      result.push({ type: "icon", content: "￥" });
      result.push({ type: "integer", content: parts[0] });
      if (parts.length > 1) {
        result.push({ type: "decimal", content: "." + parts[1] });
      } else {
        result.push({ type: "decimal", content: ".00" });
      }
      return result;
    },
    // 格式化价格
    formatPrice(priceStr) {
      if (!priceStr) return [];
      const price = this.getTagValue(priceStr);
      console.log("price===", price);
      if (price.includes("~")) {
        const [minPrice, maxPrice] = price.split("~");
        const minParts = this.formatSinglePrice(minPrice);
        const maxParts = this.formatSinglePrice(maxPrice);
        return [...minParts, { type: "separator", content: " ~ " }, ...maxParts];
      }

      if (price.includes("起")) {
        const [pricePart] = price.split("起");
        const priceParts = this.formatSinglePrice(pricePart);
        return [...priceParts, { type: "suffix", content: "起" }];
      }

      if (!isNaN(Number(price))) {
        return this.formatSinglePrice(price);
      }

      return [];
    },
    // 获取价格部分的样式类
    getPriceClass(type) {
      switch (type) {
        case "icon":
          return "price-icon";
        case "integer":
          return "price-integer";
        case "decimal":
        case "suffix":
        case "separator":
          return "price-decimal";
        default:
          return "";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-tooltip__popper {
  top: -500px !important;
}
.isMoreModel {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.product-card {
  width: 100%;
  /* min-height: 410px; */
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  position: relative;
  box-sizing: border-box;
  border: 1px solid #eaeaea;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
    border: 1px solid var(--color-primary);
  }

  .image-container {
    width: 100%;
    height: 200px;
    overflow: hidden;
    position: relative;

    &:hover {
      .product-image {
        transform: scale(1.05);
      }

      .image-overlay {
        opacity: 1;
      }
    }
  }
  .image-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;

    .product-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.4s ease;
    }

    .image-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.3);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 0.3s ease;

      .overlay-icon {
        color: white;
        font-size: 24px;
      }
    }
  }
  .product-info {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 4px;

    .product-name {
      width: 100%;
      height: auto;
      min-height: 48px;
      overflow: hidden;

      .name-text {
        font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
        font-weight: 700;
        font-size: 16px;
        color: #1a1a1a;
        line-height: 1.4;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }

    .tags-section {
      display: flex;
      flex-direction: column;
      gap: 6px;
      position: relative;

      .tags-container {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        align-items: center;
        max-height: 30px; /* 限制为1行高度 */
        overflow: hidden;
        position: relative;
        padding-right: 24px;
        /* 添加渐变遮罩效果，当内容超出时显示 */
        &.has-overflow::after {
          content: "";
          position: absolute;
          bottom: 0;
          right: 0;
          width: 100%;
          height: 20px;
          background: linear-gradient(to bottom, transparent, white);
          pointer-events: none;
        }
      }
      /* 下拉按钮样式 */
      .tags-dropdown-btn {
        position: absolute;
        right: 0;
        bottom: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        background: #f5f5f5;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.2s ease;
        color: #666;
        font-size: 12px;
        flex-shrink: 0;

        &:hover {
          background: #e0e0e0;
          color: #333;
        }
      }

      .promotion-text {
        font-family: "PingFang SC", sans-serif;
        font-weight: 400;
        color: rgb(232, 79, 71);
        font-size: 12px;
        line-height: 1.4;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
      }
    }

    .price-section {
      display: flex;
      flex-shrink: 0;
      flex-direction: column;
      gap: 4px;

      .price-container {
        display: flex;
        align-items: baseline;

        .price-icon {
          font-size: 14px;
          color: #e84f47;
          font-weight: 600;
        }

        .price-integer {
          font-size: 22px;
          color: #e84f47;
          font-weight: 700;
          margin-left: 2px;
        }

        .price-decimal {
          font-size: 14px;
          color: #e84f47;
          font-weight: 600;
        }

        .price-unit {
          color: #999;
          font-weight: 400;
          font-size: 12px;
          margin-left: 4px;
        }
      }
    }
    .original-price {
      font-size: 13px;
      font-family: "PingFang SC", sans-serif;
      font-weight: 400;
      text-decoration: line-through;
      color: #999;
    }

    .footer-actions {
      max-width: 124px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .cart-controls {
        width: 100%;
        display: flex;
        justify-content: flex-end;

        .add-to-cart-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 8px 16px;
          background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
          color: white;
          border-radius: 6px;
          font-size: 20px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
          box-shadow: 0 2px 6px rgba(238, 90, 36, 0.3);

          &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 8px rgba(238, 90, 36, 0.4);
          }

          &:active {
            transform: translateY(0);
          }

          .cart-icon {
            font-size: 18px;
          }
        }
        .disabled-btn {
          background: #999;
          cursor: not-allowed;
          &:hover {
            transform: none;
            box-shadow: none;
          }
        }
      }
    }
  }
  /* 标签弹窗样式 */
  .tags-popup-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    .tags-popup {
      background: white;
      border-radius: 12px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
      width: 90%;
      max-width: 400px;
      max-height: 80vh;
      overflow: hidden;
      animation: popupFadeIn 0.3s ease;

      .popup-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 20px;
        border-bottom: 1px solid #f0f0f0;

        h3 {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
          color: #333;
        }

        .close-btn {
          background: none;
          border: none;
          font-size: 16px;
          color: #999;
          cursor: pointer;
          padding: 4px;
          border-radius: 4px;
          transition: all 0.2s ease;

          &:hover {
            background: #f5f5f5;
            color: #666;
          }
        }
      }

      .popup-content {
        padding: 20px;
        max-height: 300px;
        overflow-y: auto;

        .all-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }
      }
    }
  }
}

/* 弹窗动画 */
@keyframes popupFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.cursor-pointer {
  cursor: pointer;
}
</style>
